var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page__sticker",style:({ backgroundColor: _vm.backgroundColor, left: _vm.left, right: _vm.right, transform: _vm.transform })})}
var staticRenderFns = []

export { render, staticRenderFns }